import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dramatic%20warm%20toned%20composition%20with%20dark%20crimson%20and%20deep%20amber%20gradients%2C%20mysterious%20atmosphere%2C%20entertainment%20media%20aesthetic%2C%20soft%20bokeh%20lights%2C%20cinematic%20mood%2C%20dark%20elegant%20background%2C%20no%20text%2C%20no%20people&width=1920&height=1080&seq=hero-bg-51cg-001&orientation=landscape"
          alt="51吃瓜爆料网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left pt-24 pb-8 lg:py-0">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-300 text-xs md:text-sm font-semibold tracking-wide mb-4">
              {heroData.tag}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-3">
              51吃瓜爆料网
              <br />
              <span className="text-accent-300">全网最全吃瓜平台</span>
            </h1>

            <p className="text-white/70 text-base md:text-lg font-heading italic mb-5">
              {heroData.slogan}
            </p>

            <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-xl lg:max-w-none mx-auto lg:mx-0 mb-6">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-300 font-label">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/50 mt-0.5">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.ctaPrimary.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.ctaPrimary.href); }}
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white px-6 py-3 rounded-full text-sm md:text-base font-semibold transition-all cursor-pointer whitespace-nowrap"
              >
                {heroData.ctaPrimary.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.ctaSecondary.href}
                onClick={(e) => { e.preventDefault(); handleClick(heroData.ctaSecondary.href); }}
                className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white px-6 py-3 rounded-full text-sm md:text-base font-medium transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-line"></i>
                {heroData.ctaSecondary.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end pb-8 lg:pb-0">
            <div className="relative w-[260px] h-[340px] md:w-[340px] md:h-[440px] rounded-2xl overflow-hidden flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=dramatic%20editorial%20photography%20style%2C%20warm%20crimson%20and%20gold%20tones%2C%20mysterious%20silhouette%20behind%20frosted%20glass%2C%20abstract%20entertainment%20news%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20faces%2C%20dark%20elegant%20moody%20atmosphere&width=800&height=1000&seq=hero-visual-51cg-002&orientation=portrait"
                alt="51吃瓜爆料网主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}